// Generated with util/create-component.js
import React, { useEffect, useState } from "react";

import { TextAreaProps } from "./TextArea.types";

import "./TextArea.scss";

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  valid,
  disabled,
  placeholder,
  hasIcon,
  id,
  name,
}) => {
  return (
    <>
      <textarea
        data-testid="input"
        className={`mp-atoms-input--main ${valid && "valid"} ${
          hasIcon && "hasIcon"
        }`}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        id={id}
        name={name}
      />
    </>
  );
};

export default TextArea;
